module.exports = __webpack_public_path__ + "images/search-overlay-chevron.svg";